var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18619",
    "data-name": "Rectangle 18619",
    width: 72.059,
    height: 120,
    fill: "#0050ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23586",
    "data-name": "Group 23586",
    transform: "translate(-314 -1357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23578",
    "data-name": "Group 23578",
    transform: "translate(248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 -304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49983",
    "data-name": "Path 49983",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 1644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23582",
    "data-name": "Group 23582",
    transform: "translate(134 1402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23582-2",
    "data-name": "Group 23582",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49994",
    "data-name": "Path 49994",
    d: "M10.481,120c-1.845-.788-3.877-1.3-5.5-2.419-3.529-2.432-4.992-6.032-4.981-10.3C.03,97.365.012,87.447.012,77.529Q.012,45.2,0,12.867a12.3,12.3,0,0,1,4.84-10.4A12.09,12.09,0,0,1,12.48,0q18.453.034,36.906.01c3.4,0,6.8-.007,10.193,0A12.078,12.078,0,0,1,72.041,12.164c.029,1.053.006,2.108.006,3.163q0,45.919.012,91.839c0,4.306-1.415,7.952-4.984,10.414-1.618,1.116-3.651,1.631-5.5,2.419ZM6.027,60.005q0,23.607,0,47.215c0,4.358,2.373,6.759,6.714,6.761q23.26.012,46.52,0c4.417,0,6.77-2.383,6.77-6.823q0-47.157,0-94.313c0-4.439-2.354-6.819-6.773-6.821Q36,6.016,12.739,6.031a8.958,8.958,0,0,0-2.2.207c-2.866.738-4.5,3.055-4.506,6.317q-.008,23.725,0,47.45",
    transform: "translate(0 0.001)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49995",
    "data-name": "Path 49995",
    d: "M108.341,345.9a5.976,5.976,0,0,1-5.971-5.953,5.987,5.987,0,1,1,11.974.034,5.971,5.971,0,0,1-6,5.919",
    transform: "translate(-72.328 -235.939)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49996",
    "data-name": "Path 49996",
    d: "M118.1,40.1c-1.911,0-3.822.023-5.732-.006a2.978,2.978,0,1,1-.014-5.944q5.849-.044,11.7,0a2.973,2.973,0,1,1,.013,5.939c-1.988.035-3.977.008-5.966.009",
    transform: "translate(-77.15 -24.114)",
    fill: "#0050ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49997",
    "data-name": "Path 49997",
    d: "M78.093,40.158a2.966,2.966,0,1,1,2.971-3,3.073,3.073,0,0,1-2.971,3",
    transform: "translate(-53.032 -24.182)",
    fill: "#0050ad"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f1d290699ac86bcc3d02083517dce291.svg";
export { ForwardRef as ReactComponent };